<div class="payment-success" [style.font-family]="'var(--vex-font)'">
  <h1>Payment Successful!</h1>
  <p>Your payment was successful. Thank you for your purchase!</p>
</div>
